import { useQuery } from "@apollo/client";

import { SettingsSpeciesEditRoute_GetByIdDocument } from "../queries.generated";

export default function useSettingsSpeciesEditRoute_GetById(speciesId: string) {
    const { data, loading, error } = useQuery(SettingsSpeciesEditRoute_GetByIdDocument, {
        variables: { id: speciesId },
    });

    return {
        species: data?.settingsSpeciesGetById,
        loading,
        error,
    };
}
